import { Component, OnInit, AfterViewInit, ElementRef, ViewChild, Input, OnChanges } from '@angular/core';
import MetisMenu from 'metismenujs';
import { EventService } from '../../core/services/event.service';
import { Router, NavigationEnd, RouterModule } from '@angular/router';

import { HttpClient } from '@angular/common/http';

import { MENU } from './menu';
import { MenuItem } from './menu.model';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { SimplebarAngularModule } from 'simplebar-angular';
import { CommonModule } from '@angular/common';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  standalone:true,
  imports:[SimplebarAngularModule,RouterModule,CommonModule,TranslateModule ]
})

/**
 * Sidebar component
 */
export class SidebarComponent implements OnInit, AfterViewInit, OnChanges {
  @ViewChild('componentRef') scrollRef;
  @Input() isCondensed = false;
  menu: any;
  data: any;

  menuItems: MenuItem[] = [];

  eventId: string | null = null;

  @ViewChild('sideMenu') sideMenu: ElementRef;

  constructor(private eventService: EventService, private router: Router, public translate: TranslateService, private http: HttpClient, private route: ActivatedRoute) {
    router.events.forEach((event) => {
      if (event instanceof NavigationEnd) {
        this._rebuildMenuItems();
        this._activateMenuDropdown();
        this._scrollElement();
      }
    });
  }

  ngOnInit() {
    this._rebuildMenuItems();
  }

  private _getEventIdFromRouter(): string | null {
    // Prefer the new canonical route param (/events/:eventId/...).
    let current = this.router.routerState.snapshot.root;
    while (current) {
      const eventId = current.paramMap.get('eventId');
      if (eventId) return eventId;
      current = current.firstChild as any;
    }

    // Legacy fallback (?eventId=...)
    return this.router.routerState.snapshot.root.queryParamMap.get('eventId');
  }

  private _rebuildMenuItems() {
    this.eventId = this._getEventIdFromRouter();
    const eventId = this.eventId;

    this.menuItems = MENU.map(item => {
      if (!eventId) {
        return { ...item, queryParams: undefined } as any;
      }

      if (item.label === 'Sponsors') return { ...item, path: `/events/${eventId}/sponsors`, queryParams: undefined };
      if (item.label === 'Committees') return { ...item, path: `/events/${eventId}/committees`, queryParams: undefined };
      if (item.label === 'Presentations') return { ...item, path: `/events/${eventId}/presentations`, queryParams: undefined };
      if (item.label === 'Sessions') return { ...item, path: `/events/${eventId}/sessions`, queryParams: undefined };
      if (item.label === 'Participants') return { ...item, path: `/events/${eventId}/participants`, queryParams: undefined };
      if (item.label === 'Discussions') return { ...item, path: `/events/${eventId}/discussions`, queryParams: undefined };
      if (item.label === 'Home') return { ...item, path: `/events/${eventId}/view`, queryParams: undefined };
      if (item.label === 'Venues & Floor Maps') return { ...item, path: `/events/${eventId}/venues`, queryParams: undefined };
      if (item.label === 'Statistics') return { ...item, path: `/events/${eventId}/statistics`, queryParams: undefined };
      if (item.label === 'Q&A') return { ...item, path: `/events/${eventId}/qna`, queryParams: undefined };
      if (item.label === 'Events') return { ...item, path: '/', queryParams: undefined };

      return item;
    });
  }


  ngAfterViewInit() {
    this.menu = new MetisMenu(this.sideMenu.nativeElement);
    this._activateMenuDropdown();
  }

  toggleMenu(event) {
    event.currentTarget.nextElementSibling.classList.toggle('mm-show');
  }

  ngOnChanges() {
    if (!this.isCondensed && this.sideMenu || this.isCondensed) {
      setTimeout(() => {
        this.menu = new MetisMenu(this.sideMenu.nativeElement);
      });
    } else if (this.menu) {
      this.menu.dispose();
    }
  }
  _scrollElement() {
    setTimeout(() => {
      if (document.getElementsByClassName("mm-active").length > 0) {
        const currentPosition = document.getElementsByClassName("mm-active")[0]['offsetTop'];
        if (currentPosition > 500)
          if (this.scrollRef.SimpleBar !== null)
            this.scrollRef.SimpleBar.getScrollElement().scrollTop =
              currentPosition + 300;
      }
    }, 300);
  }

  /**
   * remove active and mm-active class
   */
  _removeAllClass(className) {
    const els = document.getElementsByClassName(className);
    while (els[0]) {
      els[0].classList.remove(className);
    }
  }

  /**
   * Activate the parent dropdown
   */
  _activateMenuDropdown() {
    this._removeAllClass('mm-active');
    this._removeAllClass('mm-show');
    const links = document.getElementsByClassName('side-nav-link-ref');
    let menuItemEl = null;
    // tslint:disable-next-line: prefer-for-of
    const paths = [];
    for (let i = 0; i < links.length; i++) {
      paths.push(links[i]['pathname']);
    }
    var itemIndex = paths.indexOf(window.location.pathname);
    if (itemIndex === -1) {
      const strIndex = window.location.pathname.lastIndexOf('/');
      const item = window.location.pathname.substr(0, strIndex).toString();
      menuItemEl = links[paths.indexOf(item)];
    } else {
      menuItemEl = links[itemIndex];
    }
    if (menuItemEl) {
      menuItemEl.classList.add('active');
      const parentEl = menuItemEl.parentElement;
      if (parentEl) {
        parentEl.classList.add('mm-active');
        const parent2El = parentEl.parentElement.closest('ul');
        if (parent2El && parent2El.id !== 'side-menu') {
          parent2El.classList.add('mm-show');
          const parent3El = parent2El.parentElement;
          if (parent3El && parent3El.id !== 'side-menu') {
            parent3El.classList.add('mm-active');
            const childAnchor = parent3El.querySelector('.has-arrow');
            const childDropdown = parent3El.querySelector('.has-dropdown');
            if (childAnchor) { childAnchor.classList.add('mm-active'); }
            if (childDropdown) { childDropdown.classList.add('mm-active'); }
            const parent4El = parent3El.parentElement;
            if (parent4El && parent4El.id !== 'side-menu') {
              parent4El.classList.add('mm-show');
              const parent5El = parent4El.parentElement;
              if (parent5El && parent5El.id !== 'side-menu') {
                parent5El.classList.add('mm-active');
                const childanchor = parent5El.querySelector('.is-parent');
                if (childanchor && parent5El.id !== 'side-menu') { childanchor.classList.add('mm-active'); }
              }
            }
          }
        }
      }
    }

  }

  /**
   * Initialize
   */
  initialize(): void {
    this.menuItems = MENU.map(item => {
      if (item.useEventId && this.eventId) {
        return {
          ...item,
          link: undefined, // avoid using full encoded string
          routerLink: [item.link],
          queryParams: { [item.queryParamKey]: this.eventId }
        };
      }
      return item;
    });
  }



  /**
   * Returns true or false if given menu item has child or not
   * @param item menuItem
   */
  hasItems(item: MenuItem) {
    return item.subItems !== undefined ? item.subItems.length > 0 : false;
  }
}
